<div
  class="alain-default__nav-item d-flex align-items-center px-sm mobile-min-width-user"
  nz-dropdown
  nzTrigger="click"
  nzPlacement="bottomCenter"
  nzOverlayClassName="header-dropdown"
  [nzDropdownMenu]="userMenu"
>
  <nz-avatar
    [nzSrc]="user['pictureUrl']"
    nzIcon="user"
    nzSize="small"
    class="mr-sm avatar"
    style="background-color:#00174d;color:white"
  ></nz-avatar>
  <!-- <span class="hide-this">{{ user['displayName'] }}</span> -->
</div>
<nz-dropdown-menu #userMenu="nzDropdownMenu">
  <div nz-menu class="width-md header-extend">
    <div class="header-user-profile">
      <nz-avatar
        [nzSrc]="user['pictureUrl']"
        nzIcon="user"
        nzSize="default"
        class="header-user-profile__avatar"
        style="background-color:#00174d;color:white"
        [attr.aria-label]="user['displayName'] || 'User avatar'"
      ></nz-avatar>
      <div class="header-user-profile__info">
        <div class="header-user-profile__name">{{ user['displayName'] }}</div>
        <div class="header-user-profile__email">{{ user['email'] }}</div>
      </div>
    </div>
    <div nz-menu-item routerLink="/account/companies">
      <i nz-icon nzType="appstore" class="mr-sm"></i>
      My Companies
    </div>
    <div nz-menu-item routerLink="/account/settings">
      <i nz-icon nzType="setting" class="mr-sm"></i>
      Account Settings
    </div>
    <div nz-menu-item routerLink="/company/adv-opts">
      <i nz-icon nzType="tool" class="mr-sm"></i>
      Advanced Options
    </div>

    <div
      *ngIf="company && !company['isSample'] && company['isOwner']"
      nz-menu-item
      (click)="showManagePlan()"
    >
      <i nz-icon nzType="container" class="mr-sm"></i>
      Manage Plan
    </div>

    <li nz-menu-divider></li>
    <div nz-menu-item>
      <i nz-icon nzType="read" class="mr-sm"></i>
      <a
        style="color: unset;"
        [href]="academyLink"
        target="_blank"
        rel="noopener noreferrer"
      >
        QNE Academy
      </a>
    </div>
    <div nz-menu-item>
      <i nz-icon nzType="global" class="mr-sm"></i>
      <a
        style="color: unset;"
        [href]="websiteLink"
        target="_blank"
        rel="noopener noreferrer"
      >
        QNE Website
      </a>
    </div>
    <div nz-menu-item>
      <i nz-icon nzType="read" class="mr-sm"></i>
      <a
        style="color: unset;"
        [href]="youtubeLink"
        target="_blank"
        rel="noopener noreferrer"
      >
        Youtube Channel
      </a>
    </div>

    <li nz-menu-divider></li>
    <div nz-menu-item (click)="mobileAppQrCodeComponent.show()">
      <i nz-icon nzType="mobile" class="mr-sm"></i>
      Get QNE Accounting App
    </div>

    <div nz-menu-item *ngIf="acl.can({ ability: ['lic.paid'] })">
      <i nz-icon nzType="history" class="mr-sm"></i>
      <a
        style="color: unset;"
        [href]="releaseNotesLink"
        target="_blank"
        rel="noopener noreferrer"
      >
        Release Notes
      </a>
    </div>
    <li nz-menu-divider></li>
    <div nz-menu-item (click)="fullscreenRef.toggle()">
      <header-fullscreen #fullscreenRef></header-fullscreen>
    </div>
    <li nz-menu-divider></li>
    <div nz-menu-item (click)="logout()">
      <i nz-icon nzType="logout" class="mr-sm"></i>
      Logout
    </div>
  </div>
</nz-dropdown-menu>

<app-mobile-app-qr-code #mobileAppQrCodeComponent></app-mobile-app-qr-code>
